import {useQuery} from '@apollo/react-hooks';

import {makeDataDangerous, safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    SmsDripSequenceFragment as SmsDripSequence,
    GetSmsDripSequence as GetSmsDripSequenceQuery,
    GetSmsDripSequenceVariables as GetSmsDripSequenceQueryVariables,
} from 'nutshell-graphql-types';

import GET_SMS_DRIP_SEQUENCE from '../queries/get-sms-drip-sequence.graphql';

export const useGetSmsDripSequence = (
    dripSequenceId?: string | null
): {
    smsDripSequence: SmsDripSequence;
    isLoading: boolean;
    errorMessage: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {data, error, loading, refetch} = useQuery<
        GetSmsDripSequenceQuery,
        GetSmsDripSequenceQueryVariables
    >(GET_SMS_DRIP_SEQUENCE, {
        skip: !dripSequenceId,
        // @ts-expect-error
        variables: {dripSequenceId},
        fetchPolicy: 'cache-and-network',
    });

    const {smsDripSequence} = makeDataDangerous(data);

    return {
        smsDripSequence,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        isLoading: loading,
        refetch,
    };
};
